<template>
  <div class="row">
    <div class="col">
      <div>
        <div class="pull-right">
          <a class="btn mb-4 btn-success" href="#" @click="addtab">Add Field</a>
        </div>
        <br />
      </div>
      <label class="font-bold">Deployed Fields</label>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Display Name</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(value, key) in field_List"
            v-bind:key="key"
            @click="editfield(value)"
          >
            <td>{{ value.name }}</td>
            <td>{{ value.label }}</td>
            <td>{{ value.editorType }}</td>
          </tr>
        </tbody>
      </table>
      <label class="font-bold">Undeployed Fields</label> <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Display Name</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(value, key) in undeployed_field_List"
            v-bind:key="key"
            @click="editfield(value)"
          >
            <td>{{ value.name }}</td>
            <td>{{ value.label }}</td>
            <td>{{ value.editorType }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";
import { confirm } from "devextreme/ui/dialog";
import { alert } from "devextreme/ui/dialog";

export default {
  props: ["modulekey", "studio", "slug"],
  mounted() {
    //console.log('Component mounted.')
    this.getFieldslist();

    /* this.$watch('tags', function () {
                console.log(JSON.stringify(this.tags))
            }, {deep:true}); */
  },
  components: {
    DxForm,
    confirm,
    alert,
  },
  data() {
    return {
      draggingGroupName: "asd",
      field_List: new Object(),
      undeployed_field_List: new Object(),
    };
  },

  created() {
    //console.log('Component created.')
    //  this.$parent.$refs.fields_builder_list = this;
  },

  methods: {
    cancell() {
      alert("first tab");
    },
    addtab() {
      this.$emit("callAddTab", "#add_field");

      //this.$root.$refs.fields_builder_add_field.clear();
      //this.$root.$refs.fields_builder_add_field.getDDList();
    },
    editfield(value) {
      console.log("Field Value", value.name);
      if (value.hasOwnProperty("parent")) {
        let alertRes = alert(
          "This is child of a  group field. You Can Only  edit or delete parent of group field",
          "Alert!"
        );
        alertRes.then((dialogResult) => {});
      } else {
        // this.$root.$refs.fields_builder_add_field.showfield(key);

        //check if edit field is custom  and slug is studio
        if (!value.name.endsWith("_c") && this.slug == "studio") {
          //delete button will not be visible under this condition
          let alertRes = alert(
            "You Can't Delete Or uUpdate Default Field From Studio",
            "Alert!"
          );
          alertRes.then((dialogResult) => {});
        } else {
          this.$emit("send", {
            tabindex: 1,
            tabData: value,
            editmode: true,
          });
        }
      }
    },
    getFieldslist() {
      this.errors = {};
      console.log("hghg", this.studio);
      axios
        .get("/" + this.slug + "/field", {
          params: {
            module: this.modulekey,
            studio: this.studio,
          },
        })
        .then((response) => {
          console.log("fields", response.data);
          this.field_List = response.data.deployed;
          this.undeployed_field_List = response.data.undeployed;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            console.log(error.response.message);
            this.errors = error.response.data.errors || {};
          }
          alert("error" + this.slug);
        });
    },
  },
};
</script>
<style scoped>
.list-title {
  font-size: 16px;
  padding: 10px;
  padding-left: 30px;
  margin-bottom: -10px;
  font-weight: bold;
  cursor: pointer;
}
</style>